export default "__VITE_ASSET__CrdbEQ6M__"